import api from '../api'

export default api.resource({
  path    : 'stations',
  keyName : 'id'
})
